import React from 'react'

import { ExpandingCardSet } from 'components/article-elements/card-set/ExpandingCardSet'

import list from './regular-cube-list.json'

export const RegularCubeList: React.FC = () => {
  return <ExpandingCardSet title="Regular Cube" columns={list as any} />
}
